module.exports = __webpack_public_path__ + "img/3_Dicks_Screen_L_3_L.e2c5cc67.jpg";